import React from 'react';

import * as RichObjectTable from 'ui-library/RichObjectTable';
import {experimentalConditionValuesToString} from 'workflows/util/ExperimentalConditionUtil';
import {StageRun} from 'workflows/WorkflowConstants';

/**
 * Common structure used by all forms of input table rows.
 */
export default function SharedInputTableRow(props: SharedInputTableRowProps): JSX.Element {
  let sampleCell;
  if ('sampleCellContents' in props) {
    sampleCell = <RichObjectTable.Cell primary={true}>{props.sampleCellContents}</RichObjectTable.Cell>;
  } else {
    sampleCell = props.sampleCellFullElement;
  }
  let containerCell;
  if ('containerCellContents' in props) {
    containerCell = <RichObjectTable.Cell primary={true}>{props.containerCellContents}</RichObjectTable.Cell>;
  } else {
    containerCell = props.containerCellFullElement;
  }
  return (
    <RichObjectTable.Row>
      <RichObjectTable.Cell primary={true}>{props.checkboxCell}</RichObjectTable.Cell>
      {sampleCell}
      {containerCell}
      <RichObjectTable.Cell>{props.stageRun.name}</RichObjectTable.Cell>
      {props.experimentalConditionValueNames.map((valueName) => {
        const experimentalConditionValues = props.stageRun.stageFlowNode.experimentalConditionValues.filter(
          (value) => value.name === valueName
        );
        return (
          <RichObjectTable.Cell key={valueName}>
            {experimentalConditionValues.length > 0 ? (
              experimentalConditionValuesToString(experimentalConditionValues)
            ) : (
              <span className="u-faded">None</span>
            )}
          </RichObjectTable.Cell>
        );
      })}
    </RichObjectTable.Row>
  );
}

interface BaseSharedInputTableRowProps {
  experimentalConditionValueNames: Array<string>;
  checkboxCell: JSX.Element;
  stageRun: StageRun;
}
// Exactly one of sampleCellContents and sampleCellFullElement should be specified.
// In the common case, sampleCellContents can be specified and will be wrapped in a
// <RichObjectTable.Cell primary={true}>, but in more advanced cases (e.g. using AbsoluteDropdownContainer
// on the whole cell), sampleCellFullElement can be specified and is used as the entire cell element.
type SampleCellProps = {sampleCellContents: JSX.Element} | {sampleCellFullElement: JSX.Element};

// Exactly one of containerCellContents and containerCellFullElement should be specified, similar
// to sampleCellContents and sampleCellFullElement.
type ContainerCellProps = {containerCellContents: JSX.Element} | {containerCellFullElement: JSX.Element};

type SharedInputTableRowProps = BaseSharedInputTableRowProps & SampleCellProps & ContainerCellProps;
